import { UiSearchBarAction } from '../types/ui-search-bar-action.interface';

export const UI_SEARCH_BAR_ACTIONS: readonly UiSearchBarAction[] = [
  {
    id: 'scan',
    label: 'Skanuj',
    iconLabel: 'scan',
  },
  {
    id: 'mic',
    label: 'Nagraj głos',
    iconLabel: 'mic',
  },
  {
    id: 'filters',
    label: 'Filtry',
    iconLabel: 'filtr',
  },
];
